<template>
  <Row :gutter="10" type="flex" class="grid-list-row mx-0">
      <Col :span="3" align="middle" @click.native="$emit('openSlider')">
          <p>
            {{order.order_number}}
            <small>
              {{$moment(order.created_at).format('DD MMM YYYY')}}
            </small>
          </p>
      </Col>
      <Col :span="3" align="middle"  @click.native="$emit('openSlider')">
        <span :class="getStatusColor(order.status)">
          {{statusName(order.status)}}
         <Tooltip class="item" effect="dark" placement="bottom">
                <div slot="content" class="tooltipcontent">
                  {{getOrderType}}|{{getMovement}}|{{getPtlOrFtl}}<span v-if="trackingEnabled">| Sim Tracking</span>
                </div>
                  <span class="badge badge-bottom">
                    <svgicon :name="getSvgClassIndent" width="10" height="10" />
                    <svgicon :name="getSvgClassMovement" width="10" height="10" />
                    <svgicon v-if="isPTLOrder" name="ptl" width="12" height="12" />
                    <svgicon v-if="trackingEnabled" name="icon-simcard" width="12" height="12" />
                  </span>
         </Tooltip>
        </span>
      </Col>
      <Col :span="4" align="middle"  @click.native="$emit('openSlider')">
          <p><Ellipsis :text="routePath()" :length="20"/></p>
      </Col>
      <Col :span="4" align="middle"  @click.native="$emit('openSlider')">
          <p>{{order.transporter.name}}</p>
      </Col>
      <Col :span="3" align="middle"  @click.native="$emit('openSlider')">
         <p>
            <Ellipsis v-if="order.vehicle_type.name" :text="order.vehicle_type.name" :length="17"/>
            <small v-if="order.sources && order.sources.length && order.sources[0].loading_date">
              {{$moment(order.sources[0].loading_date).format('DD MMM YYYY | hh:mm A')}}
            </small>
         </p>
      </Col>
      <Col align="middle" class="col-push text-right">
        <!-- MARK AS DELIVERED-->
       <Popover
          placement="bottom-end"
          width="750"
          class="link-action"
          :visible-arrow="true"
          popper-class="popover-list bordered"
          :value="getmarkAsDeliveredPopover">
          <div class="popover-wrapper">
            <markasdelivered :order="order" :getBackDateConfig="avoidBackDate"
            @openCloseMarkAsDeliveredPopover="$emit('openCloseMarkAsDeliveredPopover', $event)"
            @deliverSubmit="$emit('indentMarkDeliver', $event, order.order_number)"
            />
          </div>
          <span slot="reference">
            <span class="link-action" v-on:click="$emit('openCloseMarkAsDeliveredPopover', true)"
              v-if="order.status==6 && $hasPermission('mark_as_deliver') && !isImportIndent"  >
                <svgicon name="mark-as-delivered" width="10" height="10" :original="true" />
                Mark as Delivered
            </span>
          </span>
        </Popover>

        <!-- Handed to transporter-->
        <Popover
          v-if="isImportIndent && [4,5,26,17,18,24,26].includes(order.status) &&
            $hasPermission('truck_in_truck_out')"
          placement="bottom-end"
          width="500"
          class="link-action"
          :visible-arrow="true"
          popper-class="popover-list bordered"
          :value="handedToTransPopover"
          @after-leave="$emit('openCloseHandedToTransPopover', false)">
          <div class="popover-wrapper">
            <HandedToTransporter :order="order"
              :lrForTruckout="lrForTruckout"
              :isMasterIndentActionCompleted="isMasterIndentActionCompleted"
              @openClosePopup="$emit('openCloseHandedToTransPopover', $event)"
              @submit="$emit('handedToTransporter', $event, order.order_number)"
            />
          </div>
          <span slot="reference">
            <span class="link-action" v-on:click="$emit('openCloseHandedToTransPopover', true)">
              <svgicon name="mark-as-delivered" width="10" height="10" :original="true" />
              Handed to transporter
            </span>
          </span>
        </Popover>

        <!-- Documents -->
        <span class="link-action" v-on:click="$emit('redirectToDocument')">
          <svgicon name="icon-document" width="10" height="10" :original="true" />
          Documents
        </span>
      </col>
  </Row>   
</template>
<script>
import { uniqBy } from 'lodash';
import markasdelivered  from '../list/actions/markdeliver/list'
import HandedToTransporter from "@common/components/eximlist/list/actions/HandedToTransporter";
import Sharedorder from '@common/components/SharedOrderMixins';
import  { indentStatusList } from 'pando-constants';
export default {
  props: [ 'order', 'markAsDeliveredPopover',
    'handedToTransPopover', 'avoidBackDate',
    'isImportIndent', 'clientSettings',
    'lrForTruckout'
  ],
  
  data(){
    return {
      indentStatusList,
      markAsDelivered: false,
    }
  },
  components:{
    markasdelivered,
    HandedToTransporter,
  },
  mixins: [Sharedorder],
  computed:{
    getmarkAsDeliveredPopover(){
      return this.markAsDeliveredPopover;
    },
    isMasterIndentActionCompleted() {
      let response = true;
      if ('master_action_completed' in this.order) {
        // is container Booked status
        response = this.order.master_action_completed;
      }
      return response;
    },
  },
  methods:{
    routePath() {
      const defaultLocation = { city: null, name: null };
      const { details: sourceDetail } = this.order.sources[0]  || defaultLocation;
      const { details: destinationDetail } = this.order.destinations[0] || defaultLocation;
      const destinationpoint = destinationDetail.city || destinationDetail.name;
      const sourcePoint = sourceDetail.city || sourceDetail.name;
      return sourcePoint && destinationpoint && `${sourcePoint} - ${destinationpoint}`;
    },
    statusName(id) {
      const mainStatus = this.$statusUtil.mainStatus;
      const mainStatusId = this.$statusUtil.getMainStatusId(id);
      return mainStatus.find(status => status.id === mainStatusId) &&
        mainStatus.find(status => status.id === mainStatusId).label;
    },
     getStatusColor(statusNo) {
      const color = this.indentStatusList.find(key => key.id === statusNo).color;
      return `status status-icon-bottom ${color}`;
    },
  }

}
</script>
